import { ENV } from './Config';

let userProperties = {};

export const updateGAUser = (nextUserProperties) => {
  if (typeof nextUserProperties === 'function') {
    nextUserProperties = nextUserProperties(userProperties);
  }
  userProperties = {
    ...userProperties,
    ...nextUserProperties,
    env: ENV,
  };

  window.gtag('set', 'user_properties', userProperties);
};

export const emitGAEvent = (event, data) => {
  window.gtag('event', event, data);
};

updateGAUser();
